import { render, staticRenderFns } from "./DryMillingProductionChart.vue?vue&type=template&id=0fd28b94"
import script from "./DryMillingProductionChart.vue?vue&type=script&lang=js"
export * from "./DryMillingProductionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports